import {decorate, observable, action} from "mobx"
import {defaultGeo, defaultMapGeos} from "../../utils/utils"
import {TimePeriodStore} from "./timePeriodStore"
import randomInt from "random-int"

export class LocGroupStore {
  tenantId = 1 // hard coded for now

  accountId = -1 // hard coded for now

  tagId = null //tagId equivalent selected - may need to be removed

  companyId = null

  timePeriod = new TimePeriodStore().timePeriod

  cachedCountryData = []

  cachedCountryTime = new Date()

  //GT map component state/dma distribution params
  mapGeos = defaultMapGeos

  //GT map component - update request IDs upon new map data
  updateMapGeoRequest() {
    const [requestId1, requestId2] = Array(2).fill(randomInt(10000))
    this.mapGeos.STATE.requestId = requestId1
    this.mapGeos.DMA.requestId = requestId2
  }

  showLoader = true //GT map component loader boolean

  //use this for useEffect for location groups
  locGeoTime = {
    geo: defaultGeo,
    timePeriod: this.timePeriod,
  }

  isLGSearched = false

  setIsLGSearched(bool) {
    this.isLGSearched = bool
  }

  //use this for useEffect for location groups geo service request
  geoServiceObj = {
    selected: null,
    timePeriod: this.timePeriod,
  }

  geoNonePOI = defaultGeo //use this obj when returning to location groups from locations

  mapGeoObj = this.geoServiceObj

  setGeoNonePOI(obj) {
    this.geoNonePOI = obj
  }

  setGeoServiceObj(newPoiServiceObj) {
    this.geoServiceObj = {...this.geoServiceObj, ...newPoiServiceObj}
  }

  setMapGeoObj(newPoiServiceObj) {
    this.mapGeoObj = {...this.mapGeoObj, ...newPoiServiceObj}
  }

  setLocGeoTime(newLocGeoTime) {
    this.locGeoTime = {...this.locGeoTime, ...newLocGeoTime}
  }

  setTenantId(tenantId) {
    this.tenantId = tenantId
  }

  setTagId(id) {
    this.tagId = id
  }

  setAccountId(accountId) {
    this.accountId = accountId
  }

  setCompanyId(companyId) {
    this.companyId = companyId
  }

  setMapGeos(newGeos) {
    this.mapGeos = {...this.mapGeos, ...newGeos}
  }

  setShowLoader(bool) {
    this.showLoader = bool
  }

  setCachedCountryData(data, time) {
    const filteredData = this.filterData(data)
    this.cachedCountryData = filteredData
    this.cachedCountryTime = time
  }

  filterData(data) {
    if (data) {
      let filteredGroups = data.filter((locGroup) => {
        return locGroup !== null && locGroup.name
      })
      let filteredGroupsOnVisits = filteredGroups.filter((locGroup) => {
        return locGroup !== null && locGroup.visits
      })
      return filteredGroupsOnVisits
    }
  }

  tableStates = {
    tableDataLoading: true,
    tableData: null,
    tableDataError: false,
    selected: null,
  }

  setTableStates(newTableStates) {
    this.tableStates = {...this.tableStates, ...newTableStates}
  }

  setDataAndId(resultsTop) {
    if (resultsTop.length !== 0) {
      const filteredData = this.filterData(resultsTop) //filter data
      if (filteredData.length === 0) {
        this.setTableStates({tableDataLoading: false, tableDataError: true})
      } else {
        this.setTableStates({tableData: filteredData}) //set filtered data into tableStates
        let selectedRow
        if (this.tableStates.selected === null) {
          //LG on first render
          selectedRow = filteredData[0].id || null
          this.setGeoServiceObj({selected: selectedRow}) //update
        } else {
          selectedRow = this.tableStates.selected
        }
        // this.setTableStates({ tableDataLoading: false, tableData: filteredData, selected: selectedRow });
        this.setTableStates({tableData: filteredData})

        if (this.isLGSearched) {
          //if LG is a search item
          this.displayRow(this.tagId)
        } else {
          this.setTableStates({tableDataLoading: false, selected: selectedRow})
        }
      }
    }
  }

  displayRow(tagId) {
    const {tableData} = this.tableStates

    //find row if exists
    const searchedLG = tableData.find((obj) => obj.id === tagId)
    if (typeof searchedLG !== "undefined") {
      this.setTableStates({selected: searchedLG.id})
    } else {
      console.error("locGroupStore.js line 146: ERROR - SEARCHED LG NOT FOUND")
    }
    this.setTableStates({tableDataLoading: false})
    this.setIsLGSearched(false)
  }
}

decorate(LocGroupStore, {
  tenantId: observable,
  accountId: observable,
  tagId: observable,
  companyId: observable,
  locGeoTime: observable,
  cachedCountryData: observable,
  tableStates: observable,
  timePeriod: observable,
  showLoader: observable,
  geoServiceObj: observable,
  mapGeos: observable,
  mapGeoObj: observable,

  setLocGeoTime: action,
  setTenantId: action,
  setAccountId: action,
  setDataAndId: action,
  setCompanyId: action,
  setTableStates: action,
  filterData: action,
  setCachedCountryData: action,
  setTagId: action,
  setShowLoader: action,
  setGeoServiceObj: action,
  setMapGeos: action,
  setMapGeoObj: action,
  updateMapGeoRequest: action,
})
